import { useEffect, useState } from "react";
import "./SingleSolvedTicket.scss";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import SendEmailModal from "../../components/sendEmailModal/SendEmailModal";

import useFetch from "../../hooks/useFetch";
import { formatDate } from "../../helper/helper";
const SingleSolvedTicket = () => {
  const [ticketSolved, setTicketSolved] = useState({}); // ganti dari array ke null atau {}
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const { ticketId } = useParams();
  const { data: solvedData, loading, error } = useFetch(`/solve/${ticketId}`);
  const { data: closeData } = useFetch(`/closed/${ticketId}`);

  useEffect(() => {
    if (solvedData && Object.keys(solvedData).length > 0) {
      setTicketSolved({
        ...solvedData,
        tt_aging: closeData?.tt_aging || solvedData.tt_aging,
      });
    }
  }, [solvedData, closeData?.tt_aging]);

  const dateTicket = () => {
    const dateCreated = formatDate(ticketSolved.created_at);
    const dateUpdate = formatDate(ticketSolved.updated_at);
    const downTime = formatDate(ticketSolved.down_time);
    const UpTime = formatDate(ticketSolved.up_time);
    const dateSubmit = formatDate(ticketSolved.date_submit);

    const date = {
      create_at: dateCreated,
      updated_at: dateUpdate,
      down_time: downTime,
      up_time: UpTime,
      date_submit: dateSubmit,

    }
    return date;
  }
  const date = dateTicket()

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          {loading ? (
            "loading"
          ) : (
            <div className="left">
              <Link to={`/solve/update/${ticketSolved.ticket_id}`} style={{ textDecoration: "none" }}>
                <div className="editButton">Edit</div>
              </Link>
              <div>
                <Link to={`/solve/time/${ticketSolved.ticket_id}`} style={{ textDecoration: "none" }}>
                  <div className="timeButton">Update TT Aging</div>
                </Link>
              </div>
              <div>
                <Link to={`/closed/create/${ticketSolved.ticket_id}`} style={{ textDecoration: "none" }}>
                  <div className="closeButton">Create Ticket Closed</div>
                </Link>
              </div>

              <div>
                <Link to={`/solve/mass/${ticketSolved.ticket_id}`} style={{ textDecoration: "none" }}>
                  <div className="gamasButton">Create Single Ticket Gamas</div>
                </Link>
              </div>

              <div>
                <div className="emailButton" onClick={() => setOpenEmailModal(true)}>
                  ✉ Kirim Email RFO
                </div>
              </div>

              <h1 className="title">Information Ticket Solved Detail</h1>
              <div className="item">
                <img
                  src="https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                  alt=""
                  className="itemImg"
                />
                <div className="details">
                  <h1 className="itemTitle">Detail Ticket</h1>
                  <div className="detailItem">
                    <span className="itemKey">Date Submit:</span>
                    <span className="itemValue">{date.date_submit}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Ticket ID:</span>
                    <span className="itemValue">{ticketSolved.ticket_id}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Region : </span>
                    <span className="itemValue">{ticketSolved.region_id}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">User ID:</span>
                    <span className="itemValue">{ticketSolved.user_id}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Segment Customer:</span>
                    <span className="itemValue">
                      {ticketSolved.segment_customer}
                    </span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Summary :</span>
                    <span className="itemValue">
                      {ticketSolved.summary}
                    </span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Action :</span>
                    <span className="itemValue">
                      {ticketSolved.action}
                    </span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Up Time:</span>
                    <span className="itemValue">{date.up_time}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Down Time:</span>
                    <span className="itemValue">{date.down_time}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Status ID:</span>
                    <span className="itemValue">{ticketSolved.status_id}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Category ID:</span>
                    <span className="itemValue">{ticketSolved.category_id}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Note :</span>
                    <span className="itemValue">
                      {ticketSolved.note || "-"}
                    </span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Created AT:</span>
                    <span className="itemValue">{date.create_at}.</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Last Updated AT:</span>
                    <span className="itemValue">{date.updated_at}</span>
                  </div>
                </div>
              </div>

            </div>)}
        </div>
        <div className="bottom">
          <body>
            <p>Kepada Pelanggan Yth,</p>
            <br />
            <br />

            <p>Terima kasih atas kepercayaan anda dalam menggunakan Jasa Layanan kami.<br />
              Atas ketidaknyamanan yang ditimbulkan kami sampaikan permohonan maaf.</p>
            <br />

            <table>
              <tr>
                <td><strong>NO. TT</strong></td>
                <td>: {ticketSolved.number_ticket}</td>
              </tr>
              <tr>
                <td><strong>Down Time</strong></td>
                <td>: {date.down_time}</td>
              </tr>
              <tr>
                <td><strong>UP Time</strong></td>
                <td>: {date.up_time}</td>
              </tr>
              <tr>
                <td><strong>Duration</strong></td>
                <td>: {ticketSolved.tt_aging ?? "Not Available"}</td>
              </tr>
              <tr>
                <td><strong>Rootcause</strong></td>
                <td>: {ticketSolved.summary}</td>
              </tr>
              <tr>
                <td><strong>Action</strong></td>
                <td>: {ticketSolved.action}</td>
              </tr>
              <tr>
                <td><strong>Impact Link</strong></td>
                <td>: {ticketSolved.segment_customer}</td>
              </tr>
            </table>
            <br />
            <br />


            <p>Demikian informasi yang dapat kami sampaikan. Untuk informasi lebih lanjut,
              silahkan hubungi Hotline Support kami di <strong>+62 899 0366 626</strong> atau
              <strong>+62 897 6006 629</strong> dapat E-mail.</p>
            <li>Email: support@greenet.id / noc@greenet.id</li>

            <br />
            <br />

            <p>Best Regards,<br />
              <br />
              <strong>Team NOC Greenet</strong></p>
            <br />
            <br />
          </body>
        </div>

        <SendEmailModal
          isOpen={openEmailModal}
          onClose={() => setOpenEmailModal(false)}
          ticketSolved={ticketSolved}
          dateInfo={date}
          closeData={closeData}
        />
      </div>
    </div>
  );
};

export default SingleSolvedTicket;
